import { render, staticRenderFns } from "./ViAdminViewStudentAndStaffAttendance.vue?vue&type=template&id=c07c91ac"
import script from "./ViAdminViewStudentAndStaffAttendance.vue?vue&type=script&lang=js"
export * from "./ViAdminViewStudentAndStaffAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports